import { api } from "@/http/api-client"
import type { TCategory } from "./types"

export interface IUpdateCategoryParams {
  categoryId: string
  organizationSlug: string
  name: string
}

export async function updateFinanceCategory(params: IUpdateCategoryParams) {
  const { categoryId, organizationSlug, name } = params

  return api.patch<TCategory>(`/finances/categories/${categoryId}`, {
    json: {
      name,
      organizationSlug,
    },
  })
}
